<script>
    import { sgettext } from '../../../i18n.js';
    export let row = {};
</script>

<style>
    .expired {
        color: white;
        background-color: red;
    }

    .active {
        color: white;
        background-color: #5cb85c;
    }
</style>

{#if row.expired}
    <span class="badge badge-pill expired">{sgettext('$$EXPIRED$$')}</span>
{:else}
    <span class="badge badge-pill active">{sgettext('$$ACTIVE$$')}</span>
{/if}